import { createRoute } from '@tanstack/react-router';
import type { EzyModule } from '../module';
import { AiRead } from './AiRead';

// AI đọc chứng từ (O-03). Vào từ Booking, không thêm mục menu.
const airead: EzyModule = {
  routes: (parent) => [createRoute({ getParentRoute: () => parent, path: '/airead', component: AiRead })],
};
export default airead;
